export type TrackingData = {
  action: TrackingAction;
  type: TrackingType;
  text?: string;
  /** Stable slug. Overrides `text` in the derived identifier when set. */
  analyticsId: string;
  location?: string;
  place?: string;
  destination?: string;
  screen_size?: string;
  locale_rendered?: string;
  metadata?: Record<string, any>;
};

export enum TrackingAction {
  Click = "Click",
  Visible = "Element Visible",
  FormSubmitted = "Form Submitted",
  FormStepSubmitted = "Form Step Submitted",
  Pause = "Pause",
  Play = "Play",
  End = "End",
  Close = "Close",
  Search = "Search",
  Event = "Event",
  // Lifecycle outcomes emitted by the signup flow, matching the monolith
  // signup_controller.js values so the GA/purchase-analytics funnel stays
  // continuous across the React migration.
  Completed = "completed",
  Triggered = "triggered",
}

export enum TrackingType {
  CTA = "CTA",
  Link = "Link",
  NavLink = "Nav Link",
  Button = "Button Interaction",
  Element = "Page Element",
  Form = "Form",
  FormStep = "Form Step",
  Modal = "Modal",
  Video = "Video",
  Search = "Search",
}

export type AnalyticsMetadata = {
  location: string;
  text: string;
  /**
   * Stable slug for the event, so the identifier never has to fall back to
   * rendered copy and fork once per locale. Required because the lint rule
   * cannot see an id arriving through a spread or a computed argument, and a
   * type can.
   */
  analyticsId: string;
  analyticsText?: string;
  action?: string;
  type?: TrackingType;
  metadata?: Record<string, any>;
  destination?: string;
};
